import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { RedirectCommand, Router } from '@angular/router';
import { PointsOfInterestRoute } from '../enums/points-of-interest-route';
import { PointOfInterestHelper } from '../helpers/point-of-interest.helper';

export const pointOfInterestCardResolver: ResolveFn<void> = (
  route: ActivatedRouteSnapshot,
) => {
  const pointOfInterestHelper = inject(PointOfInterestHelper);
  const router = inject(Router);

  const uuid = route.paramMap.get('uuid')!;
  pointOfInterestHelper.openModal(uuid);

  const urlTree = router.parseUrl(
    PointsOfInterestRoute.POINTS_OF_INTEREST_LIST,
  );
  return new RedirectCommand(urlTree, { replaceUrl: true });
};
